import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Hero from '../components/landingpages/Hero'
import Mission from '../components/landingpages/Mission'
import NewsPermotion from '../components/landingpages/NewsPermotion'
import DrugPricingStats from '../components/landingpages/DrugPricingStats'
import MarqueeSection from '../components/landingpages/MarqueeSection'
import WhatWeProvide from '../components/landingpages/WhatWeProvide'
// import SupportMission from '../components/landingpages/SupportMission'

export default function Home() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash === '#support-rxpose') {
            const element = document.getElementById('support-rxpose');
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    }, [location]);

    return (
        <div>
            <Hero />
            <MarqueeSection />
            <DrugPricingStats />
            <WhatWeProvide />
            <Mission />
            {/* <SupportMission /> */}
            <NewsPermotion />
        </div>
    )
}
